// extracted by mini-css-extract-plugin
export default {"wrapper":"HomeStatsCards_wrapper__dR2lX","card":"HomeStatsCards_card__LqJTS","label":"HomeStatsCards_label__BGPzF","value":"HomeStatsCards_value__TV-8J"};